/**
 * Feature flag (configured server-side as segment-backed by
 * `long_form_assessment_assessor_access`) that surfaces the DUPR App
 * "Administer Assessment" entry in the hamburger menu. Server-side start is the
 * authoritative gate; this only controls menu visibility.
 *
 * NOTE: the flag string value changed with the DUPR App rename; the remote-config
 * flag must be renamed to "DUPR_APP_ASSESSOR" in lockstep (kept in sync with the
 * server-side `DUPR_APP_ASSESSOR_FEATURE` in dupr-app-level.ts). The
 * `long_form_assessment_assessor_access` segment value is persisted and unchanged.
 */
export const DUPR_APP_ASSESSOR_FEATURE = "DUPR_APP_ASSESSOR";

/**
 * Legacy proxy-administer feature used by the standard assessment start dialog.
 * Shared here so the DUPR App and standard flows agree on the constant.
 */
export const ADMINISTER_ASSESSMENT_PROXY_FEATURE =
    "ADMINISTER_ASSESSMENT_PROXY";
